<template>
  <div class="flex flex-col gap-y-4 bg-white pt-7 md:pt-10">
    <div class="flex justify-between">
      <h2 class="text-[20px] tracking-[0px] text-black1">Contact Info</h2>
    </div>
    <ul class="flex flex-col gap-y-2">
      <li class="flex items-start">
        <AtomsParagraph2 class="label">Name: </AtomsParagraph2>
        <AtomsParagraph2 class="value mask-me w-full">{{ props.reservationFormStep2.firstName }} {{ props.reservationFormStep2.lastName }}</AtomsParagraph2>
      </li>
      <li class="flex items-start">
        <AtomsParagraph2 class="label">Email: </AtomsParagraph2>
        <AtomsParagraph2 class="value mask-me w-full">{{ props.reservationFormStep2.email }}</AtomsParagraph2>
      </li>
      <li class="flex items-start">
        <AtomsParagraph2 class="label">Phone number: </AtomsParagraph2>
        <AtomsParagraph2 class="value mask-me w-full">
          {{ props.reservationFormStep2.shouldShowSomeoneElseForm ? props.reservationFormStep2.forSomeoneElsePhoneNumber : props.reservationFormStep2.forMyselfPhoneNumber }}
        </AtomsParagraph2>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { WabunkaReservationFormStep2 } from '@/wabunka-src/features/Experience';

interface Props {
  reservationFormStep2: WabunkaReservationFormStep2;
  isDoneReservation?: boolean;
  onClickGuestInfoChangeButton?: () => void;
}

const props = defineProps<Props>();
</script>

<style scoped lang="scss">
.flex {
  li {
    .value {
      word-break: break-word;
      overflow-wrap: break-word;
    }

    .label {
      @apply mr-2 whitespace-nowrap text-black2;
    }
  }
}
</style>
